import { EditUnitView, UserOption } from '@mark43/cad-api';

export function isValidSelectedPersonnel(option?: UserOption): boolean {
    return !!option?.value;
}

export function getFirstResponderPersonnelFormValue(
    existingPersonnel: UserOption[],
    existingUnitData: EditUnitView,
    defaultPersonnel?: UserOption
) {
    if (existingPersonnel.length === 1 && defaultPersonnel) {
        const existingPersonnelIsDefaultPersonnel =
            existingPersonnel[0].value === defaultPersonnel.value;
        const existingUnitDataIncludesExistingPersonnel = existingUnitData.form.personnel.some(
            (personnel) => personnel.value === existingPersonnel[0].value
        );

        if (
            (existingPersonnelIsDefaultPersonnel && !existingUnitData.form.personnel.length) ||
            (!existingPersonnelIsDefaultPersonnel && !existingUnitDataIncludesExistingPersonnel)
        ) {
            return existingPersonnel;
        }

        if (existingPersonnelIsDefaultPersonnel && !existingUnitDataIncludesExistingPersonnel) {
            return [...existingPersonnel, ...existingUnitData.form.personnel];
        }
    }

    if (existingPersonnel.length > 1) {
        return existingPersonnel;
    }

    return existingUnitData.form.personnel;
}
